import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { withStyles, List, ListItem, Divider, ListItemText, ListItemAvatar, Avatar } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class UserList extends PureComponent {
    static propTypes = {
        usersConnected: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };
    capitalize = s => {
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
    };
    renderUserList() {
        const { usersConnected } = this.props;
        let userItems = [];

        usersConnected.map((user, userId) => {
            const lastname = this.capitalize(user.get('lastname'));
            const firstname = this.capitalize(user.get('firstname'));
            userItems.push(
                <Fragment key={userId}>
                    <ListItem key={userId}>
                        <ListItemAvatar>
                            <Avatar>{lastname[0]}</Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={`${lastname} ${firstname}`} secondary={user.get('email')} />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </Fragment>
            );
        });
        return userItems;
    }

    /* RENDERS */
    render() {
        const { classes } = this.props;

        return <List className={classes.root}>{this.renderUserList()}</List>;
    }
}

const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    }
});

function mapStateToProps(state) {
    const usersConnected = state.environments.testbench.data.Users.get('list').sort((a, b) => {
        return a.get('lastname').localeCompare(b.get('lastname'));
    });
    return {
        usersConnected
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({}, dispatch)
    )(withStyles(styles, { withTheme: true })(UserList))
);



// WEBPACK FOOTER //
// ./environments/testbench/scenes/Boxes/components/UserList.js